export enum TypesAAT {
	INITIAL = 'I',
	PROLONGATION = 'P',
}

export enum TypesMedecinsPres {
	TRAITANT_OU_MEDECIN = 'MT',
	PARTICIPANT_CABINET_GROUPE = '5',
	REMPLACANT = 'MR',
	INTERVENANT_HOSPITALISATION = 'MH',
	SPECIALITE_CONSULTE_DEMANDE_MDEDECIN_TRAITANT = 'MS',
	AUTRE_CAS = '8'
}

export enum TypesTravail {
	TEMPS_COMPLET = 'TC',
	TEMPS_PARTIEL = 'TP'
}

export enum TypesAdressePatient {
	ADRESSE_VISITE_HABITUELLE = 'AH',
	ADRESSE_AUTRE = 'AA'
}

export enum TypesSortie {
	HORAIRES_LIMITES = 'AM',
	HORAIRES_LIBRES = 'AB',
	NON_AUTORISEES = 'NA'
}

export enum StatutActivite {
	SALARIE = 'SA',
	FONCTIONNAIRE = 'FO',
	AUTRE = 'AU',
	NON_SALARIE_AGRICOLE = 'NS',
	PROFESSION_INDEPENDANTE = 'PI',
	ELU_LOCAL = 'EL',
	ARTISTE_AUTEUR = 'AR',
	SANS_EMPLOI = 'SE'
}
